<template>
  <div class="prep-budget-item-card-wrap">
    <div class="prep-budget-item-card">
      <div class="prep-budget-item-text">
        {{ itemText }}
        <div
          v-if="showActions"
          class="prep-item-actions"
        >
          <button
            type="button"
            class="prep-item-action-btn"
            title="Tétel szöveg szerkesztése"
            @click="$emit('edit-item-text', { item_id: itemId, item_text: itemText })"
          >
            <feather-icon
              icon="Edit2Icon"
              size="14"
            />
          </button>
          <button
            type="button"
            class="prep-item-action-btn danger"
            title="Almenü kapcsolat törlése"
            @click="$emit('unlink-subgroup', { item_id: itemId })"
          >
            <feather-icon
              icon="XIcon"
              size="14"
            />
          </button>
        </div>
      </div>
      <div class="prep-budget-item-fields">
        <label class="prep-budget-item-field">
          <span>Menny.</span>
          <input
            v-model="local.qty"
            type="number"
            class="prep-input"
            :readonly="!canEditQty"
            @input="emitChange"
          >
        </label>
        <label class="prep-budget-item-field">
          <span>Egys.</span>
          <input
            v-model="local.unit"
            type="text"
            class="prep-input"
            :readonly="!canEditUnit"
            @dblclick="enableUnitEditing"
            @input="emitChange"
          >
        </label>
        <label
          v-if="!hideMaterialColumns"
          class="prep-budget-item-field"
        >
          <span>{{ summaryMode ? 'Anyag összesen' : 'Anyag egységár' }}</span>
          <input
            :value="formatFt(local.material_unit_price)"
            type="text"
            class="prep-input"
            :readonly="!canEditMoney"
            @input="onMoneyInput('material_unit_price', $event.target.value)"
          >
        </label>
        <label class="prep-budget-item-field">
          <span>{{ summaryMode ? 'Díj összesen' : 'Alap Díj egységre' }}</span>
          <input
            :value="formatFt(local.base_fee_unit)"
            type="text"
            class="prep-input"
            :readonly="!canEditMoney"
            @input="onMoneyInput('base_fee_unit', $event.target.value)"
          >
        </label>
        <label
          v-if="!summaryMode && !hideMaterialColumns"
          class="prep-budget-item-field"
        >
          <span>Anyag összesen</span>
          <input
            :value="formatFt(local.material_total)"
            type="text"
            class="prep-input"
            readonly
          >
        </label>
        <label
          v-if="!summaryMode"
          class="prep-budget-item-field"
        >
          <span>Díj összesen</span>
          <input
            :value="formatFt(local.fee_total)"
            type="text"
            class="prep-input"
            readonly
          >
        </label>
        <label
          v-else
          class="prep-budget-item-field"
        >
          <span>Anyag + Díj összesen</span>
          <input
            :value="formatFt(combinedTotal)"
            type="text"
            class="prep-input"
            readonly
          >
        </label>
        <label
          v-if="showPlannedExpenseControl"
          class="prep-budget-item-field prep-budget-item-field-checkbox"
        >
          <span>Valós anyag költség</span>
          <input
            v-model="local.planned_material_cost"
            type="checkbox"
            class="prep-checkbox"
            @change="emitChange"
          >
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BudgetItemCard',
  props: {
    itemId: {
      type: [Number, String],
      default: null,
    },
    itemText: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    summaryMode: {
      type: Boolean,
      default: false,
    },
    hideMaterialColumns: {
      type: Boolean,
      default: false,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: String,
      default: 'full',
    },
    showPlannedExpenseControl: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      local: {
        qty: '',
        unit: '',
        material_unit_price: '',
        base_fee_unit: '',
        material_total: '',
        fee_total: '',
        planned_material_cost: false,
      },
      unitEditEnabled: false,
    }
  },
  computed: {
    canEditQty() {
      return this.editMode !== 'readonly'
    },
    canEditUnit() {
      if (this.editMode === 'readonly') return false
      if (this.editMode === 'qty-only') return this.unitEditEnabled
      return true
    },
    canEditMoney() {
      return this.editMode === 'full'
    },
    combinedTotal() {
      const material = this.local.material_total === '' || this.local.material_total === null || this.local.material_total === undefined
        ? 0
        : Number(this.local.material_total)
      const fee = this.local.fee_total === '' || this.local.fee_total === null || this.local.fee_total === undefined
        ? 0
        : Number(this.local.fee_total)
      return Number.isFinite(material + fee) ? material + fee : ''
    },
  },
  watch: {
    value: {
      handler(val) {
        const v = val || {}
        this.local = {
          qty: v.qty ?? '',
          unit: v.unit ?? '',
          material_unit_price: v.material_unit_price ?? '',
          base_fee_unit: v.base_fee_unit ?? '',
          material_total: v.material_total ?? '',
          fee_total: v.fee_total ?? '',
          planned_material_cost: (v.planned_expense_scope || 'none') === 'material',
        }
      },
      immediate: true,
      deep: true,
    },
    editMode() {
      this.unitEditEnabled = false
    },
  },
  methods: {
    enableUnitEditing() {
      if (this.editMode !== 'qty-only') return
      this.unitEditEnabled = true
    },
    formatFt(value) {
      if (value === '' || value === null || value === undefined) return ''
      const n = Number(value)
      if (!Number.isFinite(n)) return ''
      const rounded = Math.round(n)
      return `${rounded.toLocaleString('hu-HU')} Ft`
    },
    parseFt(value) {
      const raw = String(value || '').trim()
      if (!raw) return null
      const normalized = raw
        .replace(/Ft/gi, '')
        .replace(/\s/g, '')
        .replace(/\./g, '')
        .replace(',', '.')
      if (normalized === '' || normalized === '-') return null
      const parsed = Number(normalized)
      return Number.isFinite(parsed) ? parsed : null
    },
    onMoneyInput(field, rawValue) {
      if (!this.canEditMoney) return
      this.local[field] = this.parseFt(rawValue)
      this.emitChange()
    },
    emitChange() {
      this.$emit('change', {
        item_id: this.itemId,
        qty: this.local.qty === '' ? null : this.local.qty,
        unit: this.local.unit === '' ? null : this.local.unit,
        material_unit_price: this.local.material_unit_price === '' ? null : this.local.material_unit_price,
        base_fee_unit: this.local.base_fee_unit === '' ? null : this.local.base_fee_unit,
        material_total: this.local.material_total === '' ? null : this.local.material_total,
        fee_total: this.local.fee_total === '' ? null : this.local.fee_total,
        planned_expense_scope: this.local.planned_material_cost ? 'material' : 'none',
      })
    },
  },
}
</script>

<style scoped>
.prep-budget-item-text {
  position: relative;
}

.prep-item-actions {
  position: absolute;
  top: 0.35rem;
  right: 0.35rem;
  display: flex;
  gap: 0.3rem;
}

.prep-item-action-btn {
  border: 1px solid color-mix(in srgb, var(--prep-accent-soft) 28%, rgba(148, 163, 184, 0.35) 72%);
  background:
    linear-gradient(140deg, color-mix(in srgb, var(--prep-surface-1) 82%, #fff 18%) 0%, var(--prep-surface-2) 100%);
  color: color-mix(in srgb, var(--prep-text) 88%, #ffffff 12%);
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: transform 0.15s ease, box-shadow 0.2s ease;
}

.prep-budget-item-field-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.prep-checkbox {
  width: 1rem;
  height: 1rem;
  accent-color: #4ade80;
  cursor: pointer;
}

.prep-item-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px color-mix(in srgb, var(--prep-accent-base) 28%, transparent 72%);
}

.prep-item-action-btn.danger {
  color: color-mix(in srgb, var(--prep-danger-base) 82%, #ffd0d0 18%);
  border-color: color-mix(in srgb, var(--prep-danger-base) 36%, rgba(248, 113, 113, 0.35) 64%);
}

.prep-item-action-btn.danger:hover {
  box-shadow: 0 6px 14px color-mix(in srgb, var(--prep-danger-base) 34%, transparent 66%);
}
</style>
